module.exports = __webpack_public_path__ + "img/IconBackDelete.4ed527a9.svg";